import { createAuthClient } from 'better-auth/react';
import { adminClient, oneTapClient } from 'better-auth/client/plugins';

export const authClient = createAuthClient({
	baseURL: process.env.NEXT_PUBLIC_APP_URL || 'http://localhost:3000',
	plugins: [
		adminClient(),
		oneTapClient({
			clientId: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID || '',
			additionalOptions: {
				use_fedcm_for_prompt: false
			}
		})
	]
});

export const { signIn, signOut, signUp, useSession, oneTap } = authClient;
